<template>
  <div class="navbar">
    <div class="items">
      <div v-if="sideBar" class="nav-links-column">
        <a
          v-for="(item, index) in menuItems"
          :key="index"
          class="link"
          :href="item.href"
        >
          <span @click="$router.push(item.addres), (sideBar = false)">{{
            item.name
          }}</span>
        </a>
      </div>
      <div class="logo">
        <div @click="openSideBar" class="hambtn">
          <span :class="{ cross1: sideBar }" class="lines"></span>
          <span :class="{ hidden: sideBar }" class="lines"></span>
          <span :class="{ cross2: sideBar }" class="lines"></span>
        </div>
        <img
          @click="$router.push('/')"
          src="/Logo.svg"
          alt=""
          width="45"
          height="45"
        />
        <span @click="$router.push('/')"> Novinex </span>
      </div>
      <div class="nav-links">
        <span v-for="(item, index) in menuItems" :key="index" class="link">
          <a :href="item.href" @click="$router.push(item.addres)">{{
            item.name
          }}</a>
        </span>
      </div>
    </div>
    <div class="left">
      <div class="btns">
        <button @click="$router.push('/login')" class="link">ورود</button>
        <button @click="$router.push('/signup')" class="submit">ثبت نام</button>
      </div>
      <!-- <label class="switch">
        <input @change="changeTheme" type="checkbox" v-model="checked" hidden />
        <span class="slider" />
        <img src="@/assets/Moon.svg" alt="moon" class="moon" />
        <img src="@/assets/Sun.svg" alt="sun" class="sun" />
      </label> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "Navbar",
  data() {
    return {
      checked: this.state.theme === "light",
      sideBar: false,
      menuItems: [
        {
          name: "بازارها",
          addres: "/market",
        },
        {
          name: "راهنمای کاربران",
          addres: "/faq",
        },
        {
          name: "کارمزد ها",
          addres: "/fee",
        },

        {
          name: "بلاگ",
          href: "https://crypto.i.cci.vistatest.site",
        },
      ],
    };
  },
  methods: {
    openSideBar() {
      this.sideBar = !this.sideBar;
    },
    changeTheme() {
      if (this.checked) {
        this.state.theme = "light";
        localStorage.theme = "light";
        document.body.classList.remove("dark");
      } else {
        this.state.theme = "dark";
        localStorage.theme = "dark";
        document.body.classList.add("dark");
      }
    },
  },
  mounted() {
    // console.log('bitch')
  },
  created: function () {
    window.addEventListener("click", (event) => {
      if (!event.target.closest(".nav-links-column,.hambtn")) {
        this.sideBar = false;
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.hidden {
  display: none;
}
.cross1 {
  transform: rotate(45deg);
}
.cross2 {
  transform: rotate(-45deg) translate(5px, -6px);
}
.navbar {
  position: fixed;
  width: 100%;
  top: 0;
  background: var(--box);
  z-index: 10;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 14px 12px;
  .btns {
    display: flex;
    align-items: center;
    flex-direction: row;
    column-gap: 8px;
    justify-content: flex-end;
    font-size: clamp(12px, 1vw, 14px);
    @media (max-width: 600px) {
      column-gap: 4px;
    }
  }
  .items {
    position: relative;
    display: flex;
    flex-direction: row;
    width: 60%;
    .logo {
      img {
        cursor: pointer;
      }
      cursor: pointer;
      display: flex;
      flex-direction: row;
      align-content: center;
      column-gap: 12px;
      .hambtn {
        z-index: 81;
        display: flex;
        flex-direction: column;
        row-gap: 5px;
        justify-content: center;
        height: 100%;
        width: 7%;
        .lines {
          transition: 300ms;
          border-radius: 10px;
          background: var(--primary-color);
          padding: 1.5px 12px;
          height: unset;
        }
      }
      span {
        align-self: center;
        height: 30px;
        font-size: clamp(14px, 2vw, 18px);
      }
    }
    .nav-links {
      width: 80%;
      display: flex;
      flex-direction: row;
      // justify-content: space-between;
      span {
        vertical-align: middle;
        font-weight: normal;
        height: 30px;
        max-width: 90px;
        font-size: clamp(12px, 2vw, 14px);
        a {
          color: var(--grey);
        }
      }
    }
    .nav-links-column {
      z-index: 80;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      box-shadow: -6px 0 15px 10px rgba(202, 202, 202, 0.685);
      background: var(--box);
      position: fixed;
      right: 0;
      top: 0;
      padding-top: 70px;
      row-gap: 20px;
      height: 100vh;
      width: 40%;
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        vertical-align: middle;
        font-weight: normal;
        height: 30px;
        max-width: 90px;
        font-size: clamp(12px, 2vw, 14px);
      }
    }
  }
}
.dark .nav-links-column {
  box-shadow: -6px 0 15px 10px rgba(0, 0, 0, 0.685) !important;
}
button {
  max-height: 35px;
  max-width: 130px;
  @media (max-width: 600px) {
    max-height: 30px;
    max-width: 48px;
  }
}
@media only screen and (max-width: 850px) {
  .items {
    width: 80% !important;
  }
}
@media only screen and (min-width: 600px) {
  //     .nav-links-column{
  //     display: none !important;
  // }
  .hambtn {
    display: none !important;
  }
}
@media only screen and (max-width: 600px) {
  .nav-links {
    display: none !important;
  }
  .logo {
    width: 100%;
  }

  .items {
    width: 80% !important;
  }
}
.left {
  display: flex;
  align-items: center;
  .btns {
    flex-shrink: 0;
    button {
      width: 76px;
    }
  }
  .switch {
    height: 40px;
    width: 85px;
    /*flex-basis: 85px;*/
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    background-color: var(--light-grey);
    position: relative;
    align-items: center;
    margin: 0;
    border-radius: 5px;
    margin-right: 8px;
    direction: ltr;
    @media (max-width: 600px) {
      height: 30px;
      width: 61px;
      margin-right: 4px;
    }

    .sun {
      z-index: 99;
      right: 0;
      width: 50%;
      height: 20px;
      cursor: pointer;
      @media (max-width: 600px) {
        height: 12px;
      }
    }

    .moon {
      z-index: 99;
      left: 0;
      width: 50%;
      height: 20px;
      cursor: pointer;
      @media (max-width: 600px) {
        height: 12px;
      }
    }
    input {
      opacity: 0;
      width: 100%;
      height: 100%;
    }
    .slider {
      position: absolute;
      cursor: pointer;
      top: 50%;
      transform: translate(-50%, -50%);
      left: 25%;
      background-color: var(--dark-primary);
      width: calc(50% - 10px);
      height: calc(100% - 10px);
      border-radius: 5px;
      transition: 0.4s;
    }

    input:checked + .slider {
      box-shadow: none;
      left: 75%;
    }
  }
}
</style>
